import React, { useState, useEffect } from 'react';
import TransParentButton from '../../../components/Atoms/TransparentButton.js/TransParentButton';
import Button from '../../../components/Atoms/buttons/button';
import TextInput from '../../../components/Atoms/Input/TextInput';

const UpdateModal = ({ isOpen, onClose, onConfirm, editingField, currentValue, setCurrentValue }) => {
  const [error, setError] = useState('');
  const [localValue, setLocalValue] = useState('');

  useEffect(() => {
    if (isOpen) {
      setLocalValue(currentValue);
      setError('');
    }
  }, [isOpen, currentValue]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    
    // Validate based on the field being edited
    if (editingField === 'fee') {
      if (newValue === '') {
        setError('Fee is required');
      } else if (isNaN(newValue) || parseFloat(newValue) < 0) {
        setError('Fee must be a positive number');
      } else if (parseFloat(newValue) > 100) {
        setError('Fee cannot exceed 100%');
      } else {
        setError('');
      }
    } else if (editingField === 'holdDay') {
      if (newValue === '') {
        setError('Hold days are required');
      } else if (!Number.isInteger(Number(newValue)) || Number(newValue) < 0) {
        setError('Hold days must be a positive integer');
      } else if (Number(newValue) > 1000) {
        setError('Hold days cannot exceed 1000');
      } else {
        setError('');
      }
    }
  };

  const handleSubmit = () => {
    if (!error) {
      // Update the parent's state with the localValue before confirming
      setCurrentValue(localValue);
      // Pass the localValue directly to onConfirm
      onConfirm(localValue);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 backdrop-blur-sm">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center w-full max-w-md mx-auto">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          {editingField === 'fee' ? 'Update Fee Amount' : 'Update Hold Days'}
        </h2>

        <div className="mb-6">
          <TextInput
            label={editingField === 'fee' ? 'Fee Amount (%)' : 'Number of Hold Days'}
            type="number"
            value={localValue}
            onChange={handleChange}
            placeholder={editingField === 'fee' ? 'Enter fee percentage' : 'Enter hold days'}
          />
          {error && <p className="text-red-500 text-sm mt-1 text-left">{error}</p>}
          <p className="text-gray-500 text-sm mt-1 text-left">
            {editingField === 'fee' 
              ? 'Maximum allowed fee is 100%' 
              : 'Maximum allowed hold period is 1000 days'}
          </p>
        </div>

        <div className="flex justify-center gap-4">
          <TransParentButton onClick={onClose}>
            Cancel
          </TransParentButton>
          <Button 
            onClick={handleSubmit}
            disabled={!!error || localValue === ''}
          >
            Save Changes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpdateModal;